import React from "react";
import Typography from "@/ui/Typography/Typography";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { useTranslation } from "react-i18next";
import Button from "@/ui/Buttons/Button/Button";
import { useNavigate } from "react-router-dom";
import { Seo, SITE_NAME } from "@/components/Seo/Seo";
import cls from "./styles.module.scss";

export const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={cls.wrapper}>
      <Seo
        title={`Страница не найдена — ${SITE_NAME}`}
        description="Такой страницы на сайте «Светлячки» нет."
        noindex
        statusCode={404}
      />
      <FlexColumn gap={24} alignItems="center">
        <Typography
          family="Manrope"
          weight="bold"
          size="9xl"
          color="var(--text-brown)"
        >
          404
        </Typography>
        <Typography
          size="xl"
          weight="medium"
          color="var(--text-dark-secondary)"
        >
          {t("errors.404")}
        </Typography>
        <Button
          variant="primary"
          onClick={() => navigate("/")}
          label={t("common.home")}
        />
      </FlexColumn>
    </div>
  );
};
